export default {
  'deployment.title': 'Deployment Operations Console',
  'deployment.subtitle':
    'Manage repositories, GitLab CI, Kubernetes runtime, and logs in one place',
  'deployment.status.success': 'Succeeded',
  'deployment.status.failed': 'Failed',
  'deployment.status.canceled': 'Canceled',
  'deployment.status.running': '構建中',
  'deployment.status.pending': 'Pending',
  'deployment.status.created': 'Created',
  'deployment.status.skipped': 'Skipped',
  'deployment.status.notDeployed': 'Not deployed',
  'deployment.message.loadFailed': 'Failed to load deployment data',
  'deployment.message.saved': 'Deployment configuration saved',
  'deployment.message.saveFailed': 'Failed to save deployment configuration',
  'deployment.message.pipelineStarted': 'GitLab CI pipeline started',
  'deployment.message.deployFailed': 'Failed to start deployment',
  'deployment.message.deleted': 'Deployment configuration deleted',
  'deployment.message.deleteFailed':
    'Failed to delete deployment configuration',
  'deployment.message.noAccessAddress': 'No access address is configured',
  'deployment.message.addressCopied': 'Access address copied',
  'deployment.message.copyFailed': 'Failed to copy access address',
  'deployment.message.logDownloaded': '日誌下載成功',
  'deployment.message.logDownloadFailed': '日誌下載失敗',
  'deployment.deploy.confirmTitle': 'Build and deploy?',
  'deployment.deploy.confirmDescription':
    'The standard GitLab CI and Helm values files will be committed to the selected branch before the pipeline starts.',
  'deployment.action.deploy': 'Build & deploy',
  'deployment.action.quickDeploy': 'Deploy',
  'deployment.action.quickLog': 'Logs',
  'deployment.action.more': 'More',
  'deployment.action.cancel': 'Cancel',
  'deployment.action.newConfiguration': 'New configuration',
  'deployment.action.edit': 'Edit',
  'deployment.action.delete': 'Delete',
  'deployment.action.save': 'Save',
  'deployment.action.refresh': 'Refresh',
  'deployment.action.viewLog': 'View log',
  'deployment.action.addVariable': 'Add variable',
  'deployment.action.deleteVariable': 'Delete variable',
  'deployment.action.addRoute': 'Add dependency route',
  'deployment.action.deleteRoute': 'Delete dependency route',
  'deployment.action.backToList': 'All deployments',
  'deployment.delete.confirm': 'Delete this deployment configuration?',
  'deployment.common.status': 'Status',
  'deployment.common.branch': 'Branch',
  'deployment.common.createdAt': 'Created',
  'deployment.common.action': 'Action',
  'deployment.list.title': 'All deployments',
  'deployment.list.description':
    'Manage build, release, and runtime status for every service in this project',
  'deployment.list.searchPlaceholder':
    'Search services, repositories, or domains',
  'deployment.list.total': 'Configurations',
  'deployment.list.deployed': 'Deployed',
  'deployment.list.attention': 'Needs attention',
  'deployment.list.service': 'Service',
  'deployment.list.endpoint': 'Endpoint',
  'deployment.list.lastDeployedAt': 'Last deployed',
  'deployment.list.noMatch': 'No matching deployment configurations',
  'deployment.list.unit': ' services',
  'deployment.list.totalPrefix': 'Total',
  'deployment.list.totalSuffix': 'items',
  'deployment.filter.label': 'Filter deployments',
  'deployment.filter.all': 'All deployments',
  'deployment.filter.deployed': 'Deployed',
  'deployment.filter.notDeployed': 'Not deployed',
  'deployment.filter.attention': 'Needs attention',
  'deployment.more.history': 'View deployment history',
  'deployment.more.logs': 'View logs',
  'deployment.more.downloadLog': '下載日誌',
  'deployment.more.configuration': 'View configuration',
  'deployment.more.copyAddress': 'Copy access address',
  'deployment.more.redeploy': 'Redeploy',
  'deployment.more.delete': 'Delete configuration',
  'deployment.empty.title': 'Start with a standard deployment configuration',
  'deployment.empty.description':
    'Select a repository and configure the service, domain, and resources to generate CI files and deploy.',
  'deployment.tab.overview': 'Overview',
  'deployment.tab.configuration': 'Manifest',
  'deployment.overview.releaseStatus': 'Release status',
  'deployment.overview.repository': 'Repository',
  'deployment.overview.endpoint': 'Endpoint',
  'deployment.overview.health': 'Instance health',
  'deployment.overview.latestPipelines': 'Recent pipelines',
  'deployment.overview.releaseContract': 'Release contract',
  'deployment.overview.podStatus': 'Pod status',
  'deployment.overview.podNode': 'Node',
  'deployment.overview.podStartedAt': 'Started at',
  'deployment.pipeline.id': 'Pipeline',
  'deployment.pipeline.commit': 'Commit',
  'deployment.pipeline.noJobs': 'Select a pipeline to view jobs',
  'deployment.pipeline.jobs': 'Pipeline jobs',
  'deployment.runtime.pod': 'Pod',
  'deployment.runtime.podIp': 'Pod IP',
  'deployment.runtime.pods': 'Instances and logs',
  'deployment.runtime.ready': 'Ready',
  'deployment.runtime.restarts': 'Restarts',
  'deployment.runtime.usage': 'Live usage',
  'deployment.runtime.replicas': 'Replica status',
  'deployment.runtime.desired': 'Desired',
  'deployment.runtime.unavailable': 'Unavailable',
  'deployment.runtime.resources': 'Resources',
  'deployment.runtime.notFound':
    'This Deployment does not exist in Kubernetes yet',
  'deployment.runtime.metricsUnavailable':
    'Metrics are unavailable (metrics-server may not be installed or RBAC permission is missing); CPU/memory usage cannot be shown',
  'deployment.log.noRunningPod': 'No running instance is available for logs',
  'deployment.form.helper':
    'Saving records the manifest only. Build & deploy commits it to GitLab and starts CI.',
  'deployment.form.tab.basic': 'Basics',
  'deployment.form.tab.runtime': 'Resources & health',
  'deployment.form.tab.variables': 'Environment variables',
  'deployment.form.source': 'Source',
  'deployment.form.sourceHint': 'Choose the repository and deployment branch',
  'deployment.form.service': 'Service',
  'deployment.form.serviceHint': 'Define the Kubernetes workload basics',
  'deployment.form.repository': 'Repository',
  'deployment.form.repositoryPlaceholder': 'Select a GitLab repository',
  'deployment.form.branch': 'Branch',
  'deployment.form.appName': 'Service name',
  'deployment.form.namespace': 'Namespace',
  'deployment.form.replicas': 'Replicas',
  'deployment.form.targetPort': 'Container port',
  'deployment.form.serviceAccountName': 'ServiceAccount (optional)',
  'deployment.form.serviceAccountNameHint':
    'Only needed for apps calling the K8s API; the ServiceAccount and its RBAC must exist beforehand. Leave empty to use the namespace default',
  'deployment.form.ingress': 'Public access',
  'deployment.form.ingressHint': 'Expose the service through a domain',
  'deployment.form.domain': 'Domain',
  'deployment.form.domainPrefixHint': '僅填寫網域前綴，固定後綴由系統自動拼接',
  'deployment.form.dependencyRoutes': 'Dependency routes',
  'deployment.form.dependencyRoutesHint':
    'Forward paths on this domain to cluster services, for example /bff → zy-example-server',
  'deployment.form.routePath': 'Ingress path',
  'deployment.form.routeServiceName': 'Target service',
  'deployment.form.routeServicePlaceholder': '選擇已有部署服務',
  'deployment.form.routeServiceEmpty': '目前專案暫無已有部署服務',
  'deployment.form.resources': 'Resources',
  'deployment.form.requests': 'Requests',
  'deployment.form.requestsHint': 'Minimum resources reserved for scheduling',
  'deployment.form.limits': 'Limits',
  'deployment.form.limitsHint': 'Maximum resources available to each replica',
  'deployment.form.cpu': 'CPU',
  'deployment.form.memory': 'Memory',
  'deployment.form.cpuRequest': 'CPU request',
  'deployment.form.cpuLimit': 'CPU limit',
  'deployment.form.memoryRequest': 'Memory request',
  'deployment.form.memoryLimit': 'Memory limit',
  'deployment.form.liveness': 'Liveness probe',
  'deployment.form.readiness': 'Readiness probe',
  'deployment.form.probeHint':
    'Determines instance health and traffic readiness',
  'deployment.form.healthPath': 'Path',
  'deployment.form.initialDelay': 'Initial delay (s)',
  'deployment.form.period': 'Period (s)',
  'deployment.form.sharedEnv': 'Shared environment variables',
  'deployment.form.sharedEnvHint':
    'Mount the zhiyue platform shared secret (zhiyue-shared-env). When disabled, only the custom variables below are used',
  'deployment.form.environmentVariables': 'Environment variables',
  'deployment.form.variablesHint': 'Sensitive values are not exposed in lists',
  'deployment.form.variableKey': 'Name',
  'deployment.form.variableValue': 'Value',
  'deployment.form.valuesFile': 'Values file',
  'deployment.common.enabled': 'Enabled',
  'deployment.common.disabled': 'Disabled',
  'deployment.validation.domainPrefix':
    '請輸入有效的二級網域前綴，僅支援小寫字母、數字和連字號，且不能以連字號開頭或結尾',
  'deployment.validation.duplicateRoute': 'Ingress paths must be unique',
  'deployment.modal.edit': 'Edit deployment configuration',
  'deployment.modal.create': 'New deployment configuration',
  'deployment.pipeline.pageTitle': 'Pipeline History',
  'deployment.pipeline.pageSubtitle':
    'Browse GitLab CI build history and job logs for each service',
  'deployment.runtime.pageTitle': 'Runtime Monitor',
  'deployment.runtime.pageSubtitle':
    'Inspect Kubernetes instances, resource usage and container logs',
  'deployment.picker.label': 'Service',
  'deployment.picker.placeholder': 'Select a deployment',
  'deployment.picker.empty.title': 'No deployment configuration yet',
  'deployment.picker.empty.description':
    'Create a deployment configuration in the console and run a deployment first.',
  'deployment.action.goConsole': 'Go to deployment console',
  'deployment.more.runtime': 'View runtime monitor',
  'deployment.overview.viewAllPipelines': 'View all',
  'deployment.log.loadFailed': 'Failed to load log',
  'deployment.log.downloading': '正在準備日誌下載…',
  'deployment.log.latestLines': 'Latest 500 lines',
  'deployment.log.loading': 'Loading log…',
  'deployment.log.empty': 'No log output',
};
